import { atomWithImmer } from "jotai-immer";

import type {
  Absence,
  AbsenceDraft,
  AbsenceStatus,
  AbsenceType,
  HolidayBalance,
  ReplacementSlot,
  ValidatedHoursNotice,
} from "../types";

export interface AbsenceManagerState {
  isVisible: boolean;
  employeeId: number | null;
  employeeName: string;
  employeeAvatarUrl: string | null;
  tab: AbsenceStatus;
  selectedId: number | null;
  absences: Absence[];
  types: AbsenceType[];
  balance: HolidayBalance | null;
  balanceLoading: boolean;
  drafts: Record<number, AbsenceDraft>;
  slots: Record<number, ReplacementSlot[]>;
  validatedHours: Record<number, ValidatedHoursNotice>;
  loadingSlots: number[];
  loading: boolean;
  saving: boolean;
  error: string | null;
}

export const initialAbsenceManagerState: AbsenceManagerState = {
  isVisible: false,
  employeeId: null,
  employeeName: "",
  employeeAvatarUrl: null,
  tab: "current",
  selectedId: null,
  absences: [],
  types: [],
  balance: null,
  balanceLoading: false,
  drafts: {},
  slots: {},
  validatedHours: {},
  loadingSlots: [],
  loading: false,
  saving: false,
  error: null,
};

export const absenceManagerAtom = atomWithImmer<AbsenceManagerState>(
  initialAbsenceManagerState,
);
